import { useSelector } from "react-redux";

import { Modal } from "@/components/General/Modal/modal";
import { useThunkDispatch } from "@/redux/dispatcher";
import {
    APIStatus,
    deleteAddress
} from "@/redux/modules/api/data/address/address.module";
import { isLoading } from "@/redux/modules/api/data/address/address.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { TApiAction } from "@/redux/store.types";

type Props = {
    isOpen: boolean;
    addressId: string;
    onClose: () => void;
};

const DeleteAddressModal = ({ isOpen, addressId, onClose }: Props) => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const isProcessingDelete = useSelector(isLoading);

    const onDelete = () => {
        dispatch(deleteAddress(addressId)).then((action: TApiAction) => {
            if (action.type === APIStatus.SUCCESS) {
                onClose();
            }
        });
    };

    return (
        <Modal
            title={t("general.address.modal.delete.title")}
            size={"sm"}
            open={isOpen}
            setOpen={onClose}
            confirmButtonText={t("general.button.delete")}
            confirmButtonColor={"danger"}
            onConfirm={onDelete}
            isConfirmDisabled={isProcessingDelete}
        >
            <p>{t("general.address.modal.delete.description")}</p>
        </Modal>
    );
};

export { DeleteAddressModal };
